import { BaseService } from 'core/services';
import ProcedureCodeRouteService from './ProcedureCodeRouteService';

class ProcedureCodeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProcedureCodeRouteService());
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }
}

export default ProcedureCodeService;
